// Base URL of the backend API (same value axios uses in services/api.js)
export const API_BASE_URL = (import.meta.env.VITE_API_URL || 'http://localhost:5001/api').replace(/\/$/, '')
